import { toLocaleStringSupportsOptions } from "./Browser";

export interface currencyOptions {
    ISOcode: string;
    symbol: string;
    precision?: number;
}

export enum formatOpties {
    None = "", // Er kan ook een lege string in de database zitten.
    B = "B",
    H = "H",
    K = "K",
    W = "W",
    O = "O"
}

export function toNumber(value: string | number | null): number {
    let nbr = 0;
    if (typeof value === "number") {
        nbr = value;
    } else if (typeof value === "string" && value) {
        let tmp = parseFloat(value.replace(",", "."));
        nbr = tmp || 0;
    }
    return nbr;
}

export function currencyToString(value: number, currencyOptions: currencyOptions): string {
    let defaults = { ISOcode: "EUR", symbol: "€", precision: null };
    let options = $.extend({}, defaults, currencyOptions);

    // ISOcode en symbol moeten altijd gevulde strings zijn
    if (!options.ISOcode || options.ISOcode.trim() === "") {
        options.ISOcode = defaults.ISOcode;
    }
    if (!options.symbol || options.symbol.trim() === "") {
        options.symbol = defaults.symbol;
    }

    let result;

    if (toLocaleStringSupportsOptions()) {
        let lsoptions = { style: "currency", currency: options.ISOcode.trim() };
        if (options.precision) {
            lsoptions = $.extend({}, lsoptions, { minimumFractionDigits: options.precision });
            // else default waarde van de browser (meestal ook 2)
        }
        result = value.toLocaleString(undefined, lsoptions);
    } else {
        // Geen support voor toLocaleString. Daarom fallbackscenario om zelf de string op te bouwen.
        var strVal = value.toFixed(options.precision || 2);

        // De punt vervangen door een komma
        strVal = strVal.replace(".", ",");
        var valutasymbool = options.symbol.trim();
        result = valutasymbool + " " + strVal;
    }

    return result;
}



export function formatTekst(tekst: string, methode: formatOpties): string {
    let str = "";
    if (typeof tekst !== "undefined" && tekst.length > 0) {
        switch (methode) {
            case formatOpties.B: // Beginnend met hoofdletter
                str = tekst.charAt(0).toLocaleUpperCase() + tekst.substring(1).toLocaleLowerCase();
                break;
            case formatOpties.H: // HOOFDLETTERS
                str = tekst.toLocaleUpperCase();
                break;
            case formatOpties.K: // kleine letters
                str = tekst.toLocaleLowerCase();
                break;
            case formatOpties.W: // Ieder Woord Een Beginhoofdletter
                str = $.map(tekst.split(" "), function (item: string) { return formatTekst(item, formatOpties["B"]); }).join(" ");
                break;
            case formatOpties.O:
            case formatOpties.None:
            default:
                str = tekst;
                break;
        }
    }
    return str;
}

// Deze functie voorziet een string (str) van voorloopkarakters (padding) tot aan de opgegeven lengte (length)
export function padl(str: string | number, padding: string, length: number): string {
    let result;
    result = str;
    if (typeof result !== 'string') {
        result = result.toString();
    }
    if (padding) {
        while (result.length < length) {
            result = padding + result;
        }
    }
    return result;
}

export function htmlEscape(str: string): string {
    return str
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\//g, '&#x2F;');
}

export function getCompositeString(partOne: string = "", partTwo: string = "", connectionChar: string = "-"): string {
    let connector = connectionChar == null || connectionChar.trim() == "" ? " " : " " + connectionChar + " ";

    if (partOne !== "" && partTwo !== "") {
        return partOne + connector + partTwo;
    } else if (partOne !== "") {
        return partOne;
    } else if (partTwo !== "") {
        return partTwo;
    } else {
        return "";
    }
}
